import countries from "i18n-iso-countries"
import cs from "i18n-iso-countries/langs/cs.json"

countries.registerLocale(cs)

const priorityCountries = ["CZ", "SK", "DE", "PL", "AT"]

export const getCountries = () => {
  const countryObj = countries.getNames("cs", { select: "official" })
  return Object.entries(countryObj)
    .map(([code, name]) => ({ code, name }))
    .filter(({ code }) => priorityCountries.includes(code))
}
